export default "__VITE_ASSET__D5LE8jFO__"